import { __rest } from 'tslib';
import React__default from 'react';
import { CheckOutlined, MinusOutlined } from '@teko/ds-icon';
import { Body } from './components/Typography.es.js';
import { CommonStyles } from './components/BaseProps.es.js';
import { styled } from '@teko/styled';

const getColor = (props, type) => {
    const displayColor = props.checked || props.partSelected;
    switch (type) {
        case 'border': {
            if (props.disabled) {
                if (displayColor)
                    return props.theme.colors.primary100;
                return props.theme.colors.divider;
            }
            else {
                if (displayColor)
                    return props.theme.colors.primary500;
                return props.theme.colors.border;
            }
        }
        case 'inner':
        default: {
            if (!displayColor)
                return props.theme.colors.white;
            return props.disabled
                ? props.theme.colors.primary100
                : props.theme.colors.primary500;
        }
    }
};
const Checkbox = (_a) => {
    var { checked = false, partSelected, disabled, onChange, children } = _a, rest = __rest(_a, ["checked", "partSelected", "disabled", "onChange", "children"]);
    return (React__default.createElement(CheckboxWrapper, Object.assign({}, rest),
        React__default.createElement(StyledCheckbox, null,
            React__default.createElement(StyledInput, { type: "checkbox", checked: checked, disabled: disabled, onChange: () => !disabled && onChange && onChange(!checked) }),
            React__default.createElement(CheckboxInner, { checked: checked, partSelected: partSelected, disabled: disabled }, partSelected ? (React__default.createElement(StyledMinusIcon, { size: 12, color: disabled ? 'primary50' : 'white' })) : (React__default.createElement(StyledCheckIcon, { size: 12, color: disabled ? 'primary50' : 'white' })))),
        children && (React__default.createElement(Body, { line: 1, marginLeft: "s4", level: 1, weight: "regular", style: { flex: 1 } }, children))));
};
const CheckboxWrapper = styled.label `
  display: inline-flex;
  align-items: center;
  line-height: unset;
  cursor: pointer;
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  ${CommonStyles}
`;
const StyledCheckIcon = styled(CheckOutlined) `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 5;
  }
`;
const StyledMinusIcon = styled(MinusOutlined) `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 4;
    stroke: ${({ theme }) => theme.colors.white};
  }
`;
const StyledCheckbox = styled.div `
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
`;
const CheckboxInner = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 1px solid ${(p) => getColor(p, 'border')};
  border-radius: 2px;
  background-color: ${(p) => getColor(p, 'inner')};
`;
const StyledInput = styled.input `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 16px;
  height: 16px;
  margin: auto;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  opacity: 0;
  ${(p) => !p.disabled
    ? `
      &:hover {
        border-color: ${({ theme }) => theme.colors.primary500};
      }
    `
    : ''}
`;

export { Checkbox as C };
